// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__ybRYj","row":"Layout_row__nDIzf","col":"Layout_col__IML6I"};